export enum AttributeStatus {
    Available = 'available',
    Processing = 'processing',
    Deleting = 'deleting',
    Stuck = 'stuck',
    Failed = 'failed',
}